import LeaderboardTile from "./LeaderboardTile";
import LeaderPointsCriteria from "../leaderboard/points-criteria";
import { useState } from "react";

const SideColumn = ({ data, type }: { data: any; type: string }) => {
  const [isPointsModalOpen, setIsPointsModalOpen] = useState(false);

  const openPointsModal = () => setIsPointsModalOpen(true);
  const closePointsModal = () => setIsPointsModalOpen(false);

  return (
    <>
      <div className="flex flex-col items-center w-full gap-6 md:w-min overflow-y-auto max-h-[calc(100vh-7rem)]">
        <div className="md:bg-white p-5 pt-1 md:pt-5 pb-2 md:pb-10 rounded-2xl min-w-80 max-w-[350px] md:w-min flex flex-col gap-5">
          <div className="text-[#090909] text-xl font-semibold leading-6 hidden md:block">
            Leaderboard Winners
          </div>
          <LeaderboardTile topUsers={data?.top3 || []} type={type} />
        </div>

        {/* <div className="p-4 mx-4 w-[350px] md:mx-0 bg-[#faf5e5] rounded-xl border border-[#ebebeb] md:flex-col justify-between md:justify-start items-center gap-4 flex">
          <div className="flex items-start md:items-center gap-2">
            <ShoppingBag size={"32"} />
            <p className="font-normal text-neutral-700 text-md text-wrap w-fit md:text-xl md:ml-3">
              Check out our merchandise in our store!
            </p>
          </div>
          <button
            type="button"
            className="text-white bg-[#007aff] rounded-3xl md:rounded-xl text-xs md:text-base font-bold py-2 md:py-3.5 px-3 md:px-20"
          >
            Explore
          </button>
        </div> */}
        <div className=" p-4 bg-white rounded-xl border border-[#ebebeb] flex-col justify-start items-start gap-3 md:inline-flex hidden">
          <div className="text-[#090909] text-xl font-['SF Pro'] leading-6">
            Instructions
          </div>
          <div className="inline-flex items-center self-stretch justify-start gap-3">
            <ol className="text-base font-normal text-neutral-700">
              <li>1. People with more XP will come on Leaderboard</li>
              <li>2. Share your success with others</li>
              <li>
                3. To gain XPs you have to perform some tasks which you can{" "}
                <span
                  className="text-[#007AFF] cursor-pointer"
                  onClick={openPointsModal}
                >
                  read here.
                </span>
              </li>
            </ol>
          </div>
        </div>
      </div>
      {isPointsModalOpen && <LeaderPointsCriteria onClose={closePointsModal} />}
    </>
  );
};

export default SideColumn;
